import { useState, useEffect, useRef, Fragment } from "react";
import ProductSettings from "./ProductSettings/ProductSettings";
import Table from "./Table/Table";
import NavigationMenu from "./NavigationMenu";
import Upload from "./Upload/Upload";
import QuotationBlock from "./ContentBlock/QuotationBlock";
import axios from "axios";
import Sidebar from "./Sidebar";
import OrderOverview from "./Account/OrderOverview";
import QuotationOverview from "./Account/QuotationOverview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-regular-svg-icons";
import { useGlobalState } from "./GlobalContext";
import { useMediaQuery } from "react-responsive";
import Settings from "./Account/Settings";
import Details from "./Account/Details";
import { useLocation } from "react-router-dom";
import LoginPopup from "./Popups/LoginPopup";
import { updateModelColor } from "./ModelViewer/ColorUpdater";
import RetrieveProductSettings from "./ProductSettings/RetrieveProductSettings";
import { getSettingsId } from "./ProductSettings/Helper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { apiLabelUrl } from "./Functions/functions";

export default function EditQuotation(props) {
    // props from react-router-dom in app.jsx
    const [modelsData, setModelsData] = useState();
    const { uploadCount } = useGlobalState();
    const [textData, setTextData] = useState(null);
    const { loggedInUser } = useGlobalState();
    const [updatingMultipleModels, setUpdatingMultipleModels] = useState(false);
    const { activeNavigationMenuItem, setActiveNavigationMenuItem, labelLogo, impersonating } = useGlobalState();
    const lastUploadedModels = useRef([]);
    // const [activeMenuItem, setActiveMenuItem] = useState(selectedMenuItem);
    const [hasModelsSelected, setHasModelsSelected] = useState(false);
    const [tempModelViewers, setTempModelViewers] = useState([]);
    const { productSettings, mandatoryProductSettings, setProductSettings, setMandatoryProductSettings, currentPage } =
        useGlobalState();
    const [loginModal, setLoginModal] = useState(false);
    const updatingPrices = useRef(false);
    const initLoadPrices = useRef(false);
    const [originalQuotationModels, setOriginalQuotationModels] = useState(null);
    const responsiveClass = "rsp-";
    const { state } = useLocation();
    const [quotationId, setQuotationId] = useState(null);
    const [quotationApiData, setQuotationApiData] = useState(null);
    const updateNextIteration = useRef(false);
    const initQuotationLoaded = useRef(false);
    const [modelsUpdaterQueue, setModelsUpdaterQueue] = useState([]);
    const [disableProductSettings, setDisableProductSettings] = useState(false);
    const defaultPreviewImage =
        import.meta.env.VITE_DEFAULT_PREVIEW_IMAGE ||
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="; // Blank base64 image
    const [afterModulSettingsUpdate, setAfterModulSettingsUpdate] = useState([]);
    const [chosenConfig, setChosenConfig] = useState(null);

    // MediaQuery variables
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1090px)" });

    useEffect(() => {
        updatingPrices.current = disableProductSettings;
    }, [disableProductSettings]);

    // Update shipping costs after updating the modelsData
    // useEffect(() => {
    //     if (afterModulSettingsUpdate.length > 0) {
    //         let updatedModels = [];
    //         afterModulSettingsUpdate.forEach((model) => {
    //             if (modelsData !== undefined && modelsData.length > 0) {
    //                 modelsData[0].data.forEach((dataModel) => {
    //                     if (dataModel.id === model.id) {
    //                         updatedModels.push(model);
    //                     }
    //                 });
    //             }
    //         });
    //     }
    // }, [modelsData]);

    useEffect(() => {
        if (updatingMultipleModels) {
            updatePricesForAllModels();
        }
    }, [updatingMultipleModels]);

    useEffect(() => {
        RetrieveProductSettings({ setMandatoryProductSettings, setProductSettings });
        setTextData(props.textData);
        // set current page if not set correctly
        if (currentPage !== "account_edit_quotation") {
            props.initLoadPage();
        }
    }, []);

    useEffect(() => {
        const init = async () => {
            let orderId = getOrderId();
            setQuotationId(orderId);
            if (orderId) {
                axios
                    .get(
                        (await apiLabelUrl("api")) +
                            `/quotation?quotation_id=${orderId}&user_id=${loggedInUser.user.id}`
                    )
                    .then((response) => {
                        if (response.data.order.admin_edited === true && !impersonating) {
                            props.navigateToPageName("home");
                            toast.error(props.textData["sections/quotation"]["not_editable"]);
                        }

                        setQuotationApiData(response.data);

                        let models = response.data.order.models;
                        models = models.map((model) => {
                            if (typeof model.amount === "undefined" || model.amount === null) {
                                model.amount = model.pivot.amount;
                            }
                            model.image = model.preview_image;
                            return model;
                        });

                        localStorage.setItem(
                            "modelsDataQuotation",
                            JSON.stringify([{ section: "quotation", data: models }])
                        );
                        setModelsData((prev) => {
                            return [{ section: "quotation", data: models }];
                        });
                        setOriginalQuotationModels((prev) => {
                            return [{ section: "quotation", data: models }];
                        });
                        initQuotationLoaded.current = true;
                        // models.forEach((model) => {
                        //     updateShippingCosts(model);
                        // });
                        calculateDeliveryTimeForMultiple(models);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        };

        init();
    }, []);

    async function calculateDeliveryTimeForMultiple(models) {
        if (!models || models.length === 0) return;

        // Prepare items array for API
        const items = models.map((model) => ({
            model_id: model.id,
            settings_id: getSettingsId(model.settings, productSettings),
            amount: model.amount,
        }));

        try {
            const response = await axios.post((await apiLabelUrl("api")) + "/calculate-shipping-time-multiple", {
                items,
            });

            if (response.data) {
                const updatedModels = models.map((model) => {
                    const deliveryInfo = response.data.find((item) => item.model_id === model.id);
                    console.log(deliveryInfo);
                    return {
                        ...model,
                        delivery: deliveryInfo ? deliveryInfo.delivery_time : null,
                    };
                });

                setModelsData([{ section: "quotation", data: updatedModels }]);
            }
        } catch (error) {
            console.error("Error calculating delivery time for multiple models:", error);
        }
    }

    function getOrderId() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("id");
    }

    useEffect(() => {
        if (tempModelViewers.length > 0) {
            setTimeout(() => {
                setTempModelViewers([]);
            }, 1000);
        }
    }, [tempModelViewers]);

    useEffect(() => {
        if (!initLoadPrices.current && typeof modelsData !== "undefined" && typeof productSettings !== "undefined") {
            updatePrices(false);
            initLoadPrices.current = true;
        }
    }, [productSettings, modelsData]);

    useEffect(() => {
        if (initQuotationLoaded.current === true) {
            getModelDataFromApi();
        }
    }, [uploadCount]);

    function getModelDataFromApi() {
        // Make a GET request for the uploaded models
        const modelDataAPI = window.location.origin + "/models";
        axios
            .get(modelDataAPI)
            .then((response) => {
                mapModelsToData(response.data)
                    .then((data) => {
                        if (data !== null) {
                            setModelsData([
                                {
                                    section: "quotation",
                                    data: data,
                                },
                            ]);
                        }
                    })
                    .catch((error) => {
                        console.error("Error retrieving mapModelsToData:", error);
                    });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const loadModelColors = async (models, orientation = null, initial = false) => {
        // Set selected models to loading state
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((stateModel) => {
                models.forEach((model) => {
                    if (stateModel.id === model.id && (stateModel.checked || initial)) {
                        stateModel.loading = true;
                    }
                });
                return stateModel;
            });

            let result = [{ ...prevState[0], data: newData }];
            return result;
        });

        setModelsUpdaterQueue((prevState) => {
            return models;
        });
    };

    const mapModelsToData = async (inputModels) => {
        // Check if data in local storage
        let localModelsData = JSON.parse(localStorage.getItem("modelsDataQuotation")) || [];
        localModelsData = typeof localModelsData[0]?.data !== "undefined" ? localModelsData[0].data : [];
        let defaultSettings = {
            application: "Retail & Industrial",
            material: "Oceanz PA12",
            color: "No colouring",
            polish: "No",
            coating: "No",
            orientation: "unlocked",
            sterile: null,
            intendedUse: null,
            clinicalUse: null,
            custom: null,
            case: null,
            practitioner: null,
        };

        // Check if current logged in user default settings are set
        if (loggedInUser?.user !== null && typeof loggedInUser?.user !== "undefined") {
            if (
                loggedInUser?.user?.default_settings !== null &&
                typeof loggedInUser?.user?.default_settings !== "undefined"
            ) {
                defaultSettings = {
                    application: loggedInUser.user.default_settings.application,
                    material: loggedInUser.user.default_settings.material,
                    color: loggedInUser.user.default_settings.color,
                    polish: loggedInUser.user.default_settings.polish,
                    coating: loggedInUser.user.default_settings.coating,
                    orientation: loggedInUser.user.default_settings.orientation,
                    sterile:
                        loggedInUser.user.default_settings.sterile === "No"
                            ? null
                            : loggedInUser.user.default_settings.sterile,
                    intendedUse: loggedInUser.user.default_settings.intendedUse,
                    clinicalUse: loggedInUser.user.default_settings.clinicalUse,
                    custom: loggedInUser.user.default_settings.custom,
                    case:
                        loggedInUser.user.default_settings.custom !== undefined &&
                        (loggedInUser.user.default_settings.custom === "Yes" ||
                            loggedInUser.user.default_settings.custom)
                            ? "-"
                            : null,
                    practitioner:
                        loggedInUser.user.default_settings.custom !== undefined &&
                        (loggedInUser.user.default_settings.custom === "Yes" ||
                            loggedInUser.user.default_settings.custom)
                            ? "-"
                            : null,
                };
            }
        }

        // If a new model is uploaded, get the new model data from API
        if (lastUploadedModels.current.length > 0) {
            const modelDataAPI = (await apiLabelUrl("web")) + "/models";
            await axios
                .get(modelDataAPI)
                .then((response) => {
                    let newUploadedModels = []; // Array to store the new uploaded models
                    let apiModels = response.data.models;
                    apiModels.map((model) => {
                        let result = {
                            id: model.id,
                            path: model.path,
                            file: model.file,
                            image: model.preview_image,
                            settings: typeof model.settings !== "undefined" ? model.settings : defaultSettings,
                            cached_model:
                                typeof model.cached_model !== "undefined" ? JSON.parse(model.cached_model) : null,
                            delivery: "...",
                            amount: 1,
                            price: "On request",
                        };

                        lastUploadedModels.current.forEach((mdl) => {
                            if (model.id === mdl.id) {
                                // Set default settings
                                result.settings = defaultSettings;

                                setModelsData((prev) => {
                                    if (!prev || !prev[0] || !prev[0].data) return prev;
                                    // Update model data
                                    let newState = prev[0].data.map((stateModel) => {
                                        if (stateModel.tempId === mdl.tempId) {
                                            stateModel = result;
                                        }
                                        return stateModel;
                                    });

                                    localStorage.setItem(
                                        "modelsDataQuotation",
                                        JSON.stringify([{ ...prev[0], data: newState }])
                                    );
                                    return [{ ...prev[0], data: newState }];
                                });

                                newUploadedModels.push(result);
                                updatePrice(result);
                                updateShippingCosts(result);
                                console.log("New model uploaded:", result);
                            }
                        });
                        return result;
                    });
                    lastUploadedModels.current = [];
                    return newUploadedModels;
                })
                .catch((error) => {
                    console.error(error);
                });
            // merge modelsData and result
            return null;
        }

        if (!!inputModels["models"]) {
            let models = inputModels["models"].map((model) => {
                let result = {
                    id: model.id,
                    path: model.path,
                    file: model.file,
                    image: model.preview_image,
                    settings: model.settings !== "undefined" ? model.settings : defaultSettings,
                    cached_model: typeof model.cached_model !== "undefined" ? JSON.parse(model.cached_model) : null,
                    delivery: "...",
                    amount: 1,
                    price: "On request",
                };

                if (localModelsData.length > 0) {
                    localModelsData.forEach((mdl) => {
                        if (mdl.id === model.id) {
                            if (typeof mdl.settings !== "undefined") {
                                result.settings = mdl.settings;
                                result.image = mdl.image;
                            } else {
                                result.settings = defaultSettings;
                            }
                        }
                    });
                }
                return result;
            });

            try {
                const localStorageData = JSON.parse(window.localStorage.getItem("modelsDataQuotation"));
                if (
                    localStorageData !== null &&
                    typeof localStorageData !== "undefined" &&
                    localStorageData.length > 0
                ) {
                    models = localStorageData[0].data.map((model) => {
                        let result = model;
                        models.forEach((mdl) => {
                            if (mdl.id === model.id) {
                                result = mdl;
                                result.image = mdl.image;
                            }
                        });
                        return result;
                    });
                } else {
                    models = [];
                }
            } catch (err) {
                console.error(err, "resetting modelsData in local storage");
                // Reset models
                models = [];
                window.localStorage.setItem("modelsDataQuotation", "[]");
            }

            calculateDeliveryTimeForMultiple(models);

            return new Promise((resolve, reject) => {
                resolve(models);
            });
        }
    };

    const savedQuotationData = [
        {
            section: "savedQuotation",
            data: [
                {
                    creation_date: "20-02-2023",
                    reference: "Tandarts nijkerk 19",
                    status: "Offerte",
                    price: "59,41",
                },
            ],
        },
    ];

    const orderData = [
        {
            section: "orders",
            orders: [
                {
                    projectnr: 2023001,
                    orderDate: "03-02-2023",
                    reference: "Tandarts nijkerk 19",
                    status: "In productie",
                    price: "59,41",
                },
                {
                    projectnr: 2024001,
                    orderDate: "05-02-2023",
                    reference: "Knieprothese",
                    status: "Verzonden",
                    price: "59,41",
                },
                {
                    projectnr: 2025001,
                    orderDate: "12-06-2023",
                    reference: "Schaakstukken",
                    status: "Afgerond",
                    price: "59,41",
                },
            ],
        },
    ];

    const productLibraryData = [
        {
            section: "library",
            data: [
                {
                    filename: "Bla.3mf",
                    settings: ["Oceanz PA14", "Brown dye", "Getrommeld", "SLS", "Polished", "Orientation"],
                    quantity: 1,
                    price: "43,99",
                },
                {
                    filename: "Test.3mf",
                    settings: ["Oceanz PA14", "Black dye", "Getrommeld", "SLS", "Polished", "Orientation"],
                    quantity: 1,
                    price: "33,99",
                },
            ],
        },
    ];

    const [orders, setOrders] = useState(orderData);
    const [products, setProducts] = useState(productLibraryData);
    const [savedQuotations, setSavedQuotations] = useState(savedQuotationData);

    // This useEffect is used to set the active menu item in the primary menu based on the current url. This is necessary if user is using
    // forward and back buttons in the browser.
    useEffect(() => {
        setActiveNavigationMenuItem(props.selectedMenuItem);
    }, [props.selectedMenuItem]);

    // This useEffect is used to set a scrollable page for the quotation section.
    useEffect(() => {
        const appContainer = document.getElementById("app");
        if (activeNavigationMenuItem === "navigate-quotation" && isTabletOrMobile) {
            appContainer.style.overflowY = "scroll";
            appContainer.style.height = "calc(95vh - 100px)";
        } else {
            appContainer.style.overflowY = "auto";
            appContainer.style.height = "100%";
        }
    }, [activeNavigationMenuItem, window.innerWidth]);

    // Callback function to receive updated settings from the product settings component.
    function updateModelSettings(config) {
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.checked === true) {
                    setAfterModulSettingsUpdate((prev) => {
                        return [...prev, model];
                    });
                    return { ...model, settings: Object.assign({}, config) };
                } else {
                    return model;
                }
            });
            let result = [{ ...prevState[0], data: newData }];
            return result;
        });
    }

    // Update the left part of screen with either the product settings or the upload component.
    useEffect(() => {
        if (updateNextIteration.current === true) {
            updatePrices();
            updateNextIteration.current = false;
        }

        let result = false;
        if (modelsData !== undefined && modelsData.length > 0) {
            if (modelsData[0].data !== undefined && modelsData[0].data.length > 0) {
                modelsData[0].data.forEach((model) => {
                    if (model.checked === true) {
                        result = true;
                    }
                });
            }
        }
        setHasModelsSelected(result);
    }, [modelsData]);

    // Handle the screenshot from the modelviewer and update the model in the database.
    function handleScreenshot(imageData, modelId, color) {
        // Set the model data locally
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.id === modelId) {
                    model.image = imageData;
                    model.color = color;
                    model.loading = false;
                }
                return model;
            });
            let result = [{ ...prevState[0], data: newData }];
            return result;
        });
    }

    function updateSelectedModelsColor(color) {
        // Get all checked models
        if (typeof modelsData !== "undefined" && modelsData.length > 0) {
            if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                // Update localstate
                setModelsData((prevState) => {
                    let models = [];
                    const newData = prevState[0].data.map((model) => {
                        if (model.checked) {
                            model.color = color;
                            model.loading = true; // set loading to true in order to show spinning loader
                            models.push(model);
                        }
                        return { ...model };
                    });
                    const result = [{ ...prevState[0], data: newData }];
                    loadModelColors(models);
                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                    return result;
                });
            }
        }
    }

    const updateModelDeliveryTime = (value) => {
        if (typeof modelsData !== "undefined" && modelsData.length > 0) {
            if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                let result = [];
                setModelsData((prevState) => {
                    const newData = prevState[0].data.map((model) => {
                        if (model.checked === true) {
                            return { ...model, delivery: value };
                        }
                        return { ...model };
                    });
                    const result = [{ ...prevState[0], data: newData }];
                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                    return result;
                });
            }
        }
    };

    const updateModelOrientation = (value) => {
        if (typeof modelsData !== "undefined" && modelsData.length > 0) {
            if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                loadModelColors(modelsData[0].data, value);
            }
        }
    };

    function saveProductSettings(chosenConfig) {
        // Save the settings to the models
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.checked === true) {
                    model.settings = Object.assign({}, chosenConfig);
                }
                return model;
            });
            const result = [{ ...prevState[0], data: newData }];
            window.localStorage.setItem("modelsData", JSON.stringify(result)); // set local storage
            return result;
        });

        // Unselect all models.
        document.getElementsByClassName("checkbox--select-all")[0].checked = false;
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.checked === true) {
                    return { ...model, checked: false, settings: chosenConfig };
                }
                return { ...model, checked: false };
            });
            const result = [{ ...prevState[0], data: newData }];
            window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage

            return result;
        });
    }

    function afterUpload(realId, tempId) {
        lastUploadedModels.current.push({ id: realId, tempId: tempId });
    }

    // Update a single model price
    const updatePrice = async (element) => {
        // Set model state to loading
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.id === element.id) {
                    model.loadingPrice = true;
                }
                return model;
            });
            return [{ ...prevState[0], data: newData }];
        });

        let params = "";
        let found = false;
        for (let setting in element.settings) {
            if (setting === "intendedUse") {
                found = true;
            }

            if (
                element.settings[setting] !== "" &&
                element.settings[setting] !== null &&
                typeof element.settings[setting] !== "undefined"
            ) {
                params +=
                    "&" + encodeURIComponent(`${setting}`) + "=" + encodeURIComponent(`${element.settings[setting]}`);
            } else {
                params += "&" + encodeURIComponent(`${setting}`) + "=null";
            }
        }
        if (!found) {
            params += "&intendedUse=null";
        }
        axios
            .get((await apiLabelUrl("api")) + `/product-price?model_id=${element.id}${params}&amount=${element.amount}`)
            .then((response) => {
                // Cant get price, show default
                if (typeof response.data.message === "undefined" && typeof response.data.data.length === "undefined") {
                    element.price = "On request";
                } else {
                    // Loop through the returned models and update the price
                    response.data.data.forEach((item) => {
                        if (item.model_id === element.id) {
                            element.price = item.unit_price;
                            element.discount_multiplier = item.discount_multiplier;
                        }
                    });
                }
                setModelsData((prevState) => {
                    const newData = prevState[0].data.map((model) => {
                        if (model.id === element.id) {
                            model.price = element.price;
                            model.loadingPrice = false;
                            model.discount_multiplier = element.discount_multiplier;
                        }
                        return model;
                    });
                    const result = [{ ...prevState[0], data: newData }];
                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                    return result;
                });
            })
            .catch((error) => {
                if (window.location.pathname === props.getPageUrlByName("account_edit_quotation").path) {
                    let result = null;
                    let found = false;
                    const localStorageData = JSON.parse(window.localStorage.getItem("modelsDataQuotation"));
                    localStorageData[0].data.forEach((m) => {
                        if (element.id === m.id && element.path === m.path) {
                            if (
                                typeof element.pivot !== "undefined" &&
                                typeof element.pivot.price !== "undefined" &&
                                element.pivot.price !== null
                            ) {
                                found = true;
                                let equalSettings = true;
                                for (let setting in element.settings) {
                                    if (element.settings[setting] !== m.settings[setting]) {
                                        equalSettings = false;
                                    }
                                }

                                setModelsData((prevState) => {
                                    const newData = prevState[0].data.map((model) => {
                                        if (model.id === element.id) {
                                            model.loadingPrice = false;
                                            model.price = "On request";
                                        }
                                        return model;
                                    });
                                    const result = [{ ...prevState[0], data: newData }];
                                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                                    return result;
                                });
                            }
                        }
                    });
                    if (!found) {
                        element.loadingPrice = false;
                        setModelsData((prevState) => {
                            const newData = prevState[0].data.map((model) => {
                                if (model.id === element.id) {
                                    model.loadingPrice = false;
                                    model.price = "On request";
                                }
                                return model;
                            });
                            const result = [{ ...prevState[0], data: newData }];
                            window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                            return result;
                        });
                    }
                    return element;
                }

                console.log(error);
                element.loadingPrice = false;
                setModelsData((prevState) => {
                    const newData = prevState[0].data.map((model) => {
                        if (model.id === element.id) {
                            model.loadingPrice = false;
                            model.price = "On request";
                        }
                        return model;
                    });
                    const result = [{ ...prevState[0], data: newData }];
                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                    return result;
                });
            })
            .finally(() => {
                updatingPrices.current = false;
                setDisableProductSettings(false);
            });
        return element;
    };

    const forceUpdatePriceForModels = async (inputModels) => {
        updatingPrices.current = true;

        // Set model state to loading
        setModelsData((prevState) => {
            if (inputModels === null || inputModels.length < 1) {
                return prevState;
            }
            if (typeof prevState[0].data === "undefined") {
                return prevState;
            }

            inputModels.forEach((model) => {
                prevState[0].data.forEach((stateModel) => {
                    if (stateModel.id === model.id) {
                        stateModel.loadingPrice = true;
                    }
                });
            });

            const newData = prevState[0].data.map((model) => {
                if (model.loadingPrice === true) {
                    model.loadingPrice = true;
                }
                return model;
            });

            return [{ ...prevState[0], data: newData }];
        });

        let modelIds = [];
        inputModels.forEach((model) => {
            modelIds.push({
                id: model.id,
                settings: getSettingsId(model.settings, productSettings),
                amount: model.amount,
            });
        });

        if (modelIds.length > 0) {
            axios
                .post((await apiLabelUrl("api")) + `/all-product-prices`, {
                    models: modelIds,
                })
                .then((response) => {
                    if (typeof response.data.data !== "undefined") {
                        response.data.data.forEach((element) => {
                            setModelsData((prevState) => {
                                const newData = prevState[0].data.map((stateModel) => {
                                    if (stateModel.id === element.model_id) {
                                        return {
                                            ...stateModel,
                                            price:
                                                parseFloat(element.unit_price) > 0 ? element.unit_price : "On request",
                                            loadingPrice: false,
                                            discount_multiplier: element.discount_multiplier,
                                        };
                                    }
                                    return stateModel;
                                });
                                const result = [{ ...prevState[0], data: newData }];
                                window.localStorage.setItem("modelsData", JSON.stringify(result)); // set local storage
                                return result;
                            });
                            setDisableProductSettings(false);
                        });
                    }
                    // Clear loading state for models not in the response
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((stateModel) => {
                            if (stateModel.loadingPrice === true) {
                                return {
                                    ...stateModel,
                                    loadingPrice: false,
                                    price: "On request",
                                };
                            }
                            return stateModel;
                        });
                        const result = [{ ...prevState[0], data: newData }];
                        window.localStorage.setItem("modelsData", JSON.stringify(result));
                        return result;
                    });
                })
                .catch((error) => {
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((model) => {
                            if (model.checked === true) {
                                model.loadingPrice = false;
                                model.price = "On request";
                            }
                            return model;
                        });
                        const result = [{ ...prevState[0], data: newData }];
                        window.localStorage.setItem("modelsData", JSON.stringify(result)); // set local storage
                        return result;
                    });
                })
                .finally(() => {
                    updatingPrices.current = false;
                });
        } else {
            setDisableProductSettings(false);
        }
        setUpdatingMultipleModels(false);
    };

    const updatePricesOnNextIteration = () => {
        updateNextIteration.current = true;
    };

    const updatePricesForAllModels = async (models = null) => {
        // Set model state to loading
        setModelsData((prevState) => {
            const newData = prevState[0].data.map((model) => {
                if (model.checked === true) {
                    model.loadingPrice = true;
                }
                return model;
            });
            return [{ ...prevState[0], data: newData }];
        });

        let modelIds = [];
        if (models === null) {
            // Update the prices for all models in one single call
            if (typeof modelsData !== "undefined" && modelsData.length > 0) {
                if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                    modelsData[0].data.forEach((model) => {
                        if (model.checked === true) {
                            modelIds.push({
                                id: model.id,
                                settings: getSettingsId(chosenConfig, productSettings),
                                amount: model.amount,
                            });
                        }
                    });
                }
            }
        } else {
            models.forEach((model) => {
                if (model.checked === true) {
                    modelIds.push({
                        id: model.id,
                        settings: getSettingsId(chosenConfig, productSettings),
                        amount: model.amount,
                    });
                }
            });
        }

        if (modelIds.length > 0) {
            axios
                .post((await apiLabelUrl("api")) + `/all-product-prices`, {
                    models: modelIds,
                })
                .then((response) => {
                    if (typeof response.data.data !== "undefined") {
                        const modelLookup = modelsData[0].data.reduce((acc, model) => {
                            acc[model.id] = model;
                            return acc;
                        }, {});

                        response.data.data.forEach((element) => {
                            const model = modelLookup[element.model_id];
                            if (model) {
                                model.price = parseFloat(element.unit_price) > 0 ? element.unit_price : "On request";
                                model.discount_multiplier = element.discount_multiplier;
                                setModelsData((prevState) => {
                                    const newData = prevState[0].data.map((stateModel) => {
                                        if (stateModel.id === model.id) {
                                            return {
                                                ...stateModel,
                                                price: model.price,
                                                loadingPrice: false,
                                                discount_multiplier: model.discount_multiplier,
                                            };
                                        }
                                        return stateModel;
                                    });
                                    const result = [{ ...prevState[0], data: newData }];
                                    window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                                    return result;
                                });
                            }
                        });
                    }
                    // Clear loading state for models not in the response
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((stateModel) => {
                            if (stateModel.loadingPrice === true) {
                                return {
                                    ...stateModel,
                                    loadingPrice: false,
                                    price: "On request",
                                };
                            }
                            return stateModel;
                        });
                        const result = [{ ...prevState[0], data: newData }];
                        window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result));
                        return result;
                    });
                })
                .catch((error) => {
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((model) => {
                            if (model.checked === true) {
                                model.loadingPrice = false;
                                model.price = "On request";
                            }
                            return model;
                        });
                        return [{ ...prevState[0], data: newData }];
                    });
                })
                .finally(() => {
                    updatingPrices.current = false;
                });
        }
        setUpdatingMultipleModels(false);
    };

    const updatePricesForModels = async (models) => {
        let modelIds = [];
        models.forEach((model) => {
            modelIds.push({
                id: model.id,
                settings: getSettingsId(model.settings, productSettings),
                amount: model.amount,
            });
        });

        axios
            .post((await apiLabelUrl("api")) + `/all-product-prices`, {
                models: modelIds,
            })
            .then((response) => {
                if (typeof response.data.data !== "undefined") {
                    const modelLookup = modelsData[0].data.reduce((acc, model) => {
                        acc[model.id] = model;
                        return acc;
                    }, {});

                    response.data.data.forEach((element) => {
                        const model = modelLookup[element.model_id];
                        if (model) {
                            model.price = parseFloat(element.unit_price) > 0 ? element.unit_price : "On request";
                            model.discount_multiplier = element.discount_multiplier;
                            setModelsData((prevState) => {
                                const newData = prevState[0].data.map((stateModel) => {
                                    if (stateModel.id === model.id) {
                                        return {
                                            ...stateModel,
                                            price: model.price,
                                            loadingPrice: false,
                                            discount_multiplier: model.discount_multiplier,
                                        };
                                    }
                                    return stateModel;
                                });
                                const result = [{ ...prevState[0], data: newData }];
                                window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result)); // set local storage
                                return result;
                            });
                        }
                    });

                    // Clear loading state for models not in the response
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((stateModel) => {
                            if (stateModel.loadingPrice === true) {
                                return {
                                    ...stateModel,
                                    loadingPrice: false,
                                    price: "On request",
                                };
                            }
                            return stateModel;
                        });
                        const result = [{ ...prevState[0], data: newData }];
                        window.localStorage.setItem("modelsDataQuotation", JSON.stringify(result));
                        return result;
                    });
                }
            })
            .catch((error) => {
                setModelsData((prevState) => {
                    const newData = prevState[0].data.map((model) => {
                        if (model.checked === true) {
                            model.loadingPrice = false;
                            model.price = "On request";
                        }
                        return model;
                    });
                    return [{ ...prevState[0], data: newData }];
                });
            })
            .finally(() => {
                updatingPrices.current = false;
                setUpdatingMultipleModels(false);
            });
    };

    // Update all selected models
    const updatePrices = async (selectedOnly = true) => {
        updatingPrices.current = true;
        let selectedModels = [];
        if (selectedOnly) {
            if (typeof modelsData !== "undefined" && modelsData.length > 0) {
                if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                    selectedModels = modelsData[0].data.filter((model) => model.checked === true);
                }
            }
        } else {
            selectedModels = modelsData[0].data;
        }

        if (modelsData[0].data.length === 0) {
            let models = JSON.parse(localStorage.getItem("modelsDataQuotation"));
            if (typeof models === "undefined" || models === null || models.length === 0) {
                updatingPrices.current = false;
                return;
            } else {
                setModelsData((prev) => {
                    return [{ data: models, section: "quotation" }];
                });
            }
        }

        // set the price for reach model if it is set in pivot price
        selectedModels.map((model) => {
            model.price = "On request";
            return model;
        });

        // Get new price

        await updatePricesForModels(selectedModels);

        // const updatePromises = selectedModels.map((element) => updatePrice(element));
        // await Promise.all(updatePromises);

        // setTimeout(() => {
        //     updatingPrices.current = false;
        // }, 500);
    };

    const saveQuotation = async (redirectToCheckout = false) => {
        if (typeof modelsData !== "undefined" && modelsData.length > 0 && typeof modelsData[0].data !== "undefined") {
            // Delete models from database that have been deleted
            originalQuotationModels[0].data.forEach((originalModel) => {
                let found = false;
                modelsData[0].data.forEach((model) => {
                    if (model.id === originalModel.id) {
                        found = true;
                    }
                });
                if (!found) {
                    // axios.delete("/models/" + originalModel.id);
                }
            });

            // Check if we need to delete the quotation (if no models are left)
            if (modelsData[0].data.length === 0) {
                axios.delete((await apiLabelUrl("api")) + "/quotation/" + quotationId);
                props.navigateToPageName("account_quotations");
                return;
            }

            // Edit the models that have been edited
            const models = modelsData[0].data;
            if (models.length > 0) {
                let modelsPayload = [];
                models.forEach((model) => {
                    // Save the new model preview image
                    // axios.post(window.location.origin + "/edit-model", {
                    //     preview: model.image,
                    //     id: model.id,
                    // });

                    // Bundle models together and sent it to update the quotation
                    let multiplier = 1;
                    if (
                        loggedInUser?.company?.price_settings !== null &&
                        loggedInUser?.company?.price_settings.allow_staffel_discount == true
                    ) {
                        multiplier = model.discount_multiplier;
                    }

                    modelsPayload.push({
                        model_id: model.id,
                        settings_id: getSettingsId(model.settings, productSettings),
                        delivery_time: model.delivery + "",
                        price: model.price + "", // Convert to string because the endpoint expects a string
                        discount_multiplier: multiplier + "",
                        discount_price:
                            model.discount_multiplier !== 1
                                ? (model.price * model.amount * multiplier).toFixed(2)
                                : null,
                        amount: model.amount,
                        case:
                            typeof model.settings.case !== "undefined" && model.settings.case !== null
                                ? model.settings.case
                                : null,
                        practitioner:
                            typeof model.settings.practitioner !== "undefined" && model.settings.practitioner !== null
                                ? model.settings.practitioner
                                : null,
                    });
                });

                console.log("Models payload to save:", modelsPayload);

                let data = {
                    quotation_id: quotationId,
                    models: modelsPayload,
                };

                axios
                    .put((await apiLabelUrl("api")) + "/quotation", JSON.stringify(data), {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .finally(function () {
                        // Check if the user is impersonating another user
                        let impersonatingDiv = document.getElementById("impersonate");
                        if (impersonatingDiv !== null && impersonatingDiv !== undefined) {
                            axios.post(window.location.origin + "/stopimpersonating").then((response) => {
                                window.location.href = window.location.origin + "/admin";
                                const urlParams = new URLSearchParams(window.location.search);
                                const id = urlParams.get("id");
                                const label_name = localStorage.getItem("label_name");
                                window.location.href =
                                    window.location.origin + "/admin/" + label_name + "/aanvragen/" + id + "/edit";
                            });
                            return;
                        }

                        if (redirectToCheckout === true) {
                            localStorage.setItem("modelsData", localStorage.getItem("modelsDataQuotation"));
                            const urlParams = new URLSearchParams(window.location.search);
                            const id = urlParams.get("id");
                            props.navigateToPageName("checkout", "?id=" + id);
                        } else {
                            props.navigateToPageName("account_quotations");
                        }
                    });
            }
        }
    };

    const saveQuotationAndRedirectCheckout = () => {
        saveQuotation(true);
    };

    const updateShippingCosts = async (model, fromTableRow = false) => {
        if (typeof modelsData !== "undefined" && modelsData[0].data.length === 0) {
            // get from localstorage
            const models = JSON.parse(window.localStorage.getItem("modelsData"));
            if (models !== null && models.length > 0) {
                setModelsData(models);
            } else {
                return;
            }
        }

        // Show the model loading
        // if (fromTableRow) {
        //     setModelsData((prevState) => {
        //         const newData = prevState[0].data.map((stateModel) => {
        //             if (stateModel.id === model.id) {
        //                 stateModel.delivery = "...";
        //             }
        //             return stateModel;
        //         });

        //         let result = [{ ...prevState[0], data: newData }];
        //         return result;
        //     });
        // }

        if (getSettingsId(model.settings, productSettings) !== "") {
            axios
                .post((await apiLabelUrl("api")) + `/calculate-shipping-time`, {
                    model_id: model.id,
                    country: "Netherlands",
                    settings_id: getSettingsId(model.settings, productSettings),
                    amount: model.amount,
                })
                .then((response) => {
                    setModelsData((prevState) => {
                        const newData = prevState[0].data.map((stateModel) => {
                            if (
                                stateModel.id === model.id &&
                                response.data !== null &&
                                response.data.delivery_time !== undefined
                            ) {
                                stateModel.delivery = parseInt(response.data.delivery_time);
                            }

                            // Check if error
                            if (response.data.error !== undefined) {
                                stateModel.delivery = 0;
                            }

                            return stateModel;
                        });

                        let result = [{ ...prevState[0], data: newData }];
                        return result;
                    });
                });
        }
    };

    const getAmountOfSelectedModels = () => {
        if (typeof modelsData !== "undefined" && modelsData.length > 0) {
            if (typeof modelsData[0].data !== "undefined" && modelsData[0].data.length > 0) {
                let selectedModels = modelsData[0].data.filter((model) => model.checked === true);
                return selectedModels.length;
            }
        }
        return 0;
    };

    return (
        <>
            {!isTabletOrMobile && (
                <div className="root">
                    {activeNavigationMenuItem === "navigate-quotation" && !!modelsData && (
                        <>
                            {!props.authenticated && loginModal && (
                                <LoginPopup
                                    textData={!!textData && textData["popups/login"]}
                                    toggleLoginModal={setLoginModal}
                                    navigateToPageName={props.navigateToPageName}
                                />
                            )}
                            <div className="screen-left">
                                {!hasModelsSelected && (
                                    <Upload
                                        textData={!!textData && textData["sections/quotation"]}
                                        afterUpload={afterUpload}
                                        setModelsData={setModelsData}
                                        setUpdatingMultipleModels={setUpdatingMultipleModels}
                                        labelLogo={labelLogo}
                                    />
                                )}
                                {hasModelsSelected && (
                                    <ProductSettings
                                        modelsData={modelsData}
                                        updateModelSettings={updateModelSettings}
                                        textData={!!textData && textData}
                                        saveProductSettings={saveProductSettings}
                                        updateSelectedModelsColor={updateSelectedModelsColor}
                                        loggedInUser={loggedInUser}
                                        updateModelColor={updateModelColor}
                                        updateModelDeliveryTime={updateModelDeliveryTime}
                                        updateModelOrientation={updateModelOrientation}
                                        updatePricesOnNextIteration={updatePricesOnNextIteration}
                                        noSharing={true}
                                        setUpdatingMultipleModels={setUpdatingMultipleModels}
                                        updatingPrices={updatingPrices.current}
                                        disableProductSettings={disableProductSettings}
                                        labelLogo={labelLogo}
                                        setChosenConfig={setChosenConfig}
                                    />
                                )}
                                <QuotationBlock textData={!!textData && textData["content_blocks/quotation"]} />
                            </div>
                            <div className="screen-right">
                                <div className="header">
                                    <div>
                                        <h1>
                                            {!!textData && textData["sections/quotation"].edit_title_before} #
                                            {getOrderId()}{" "}
                                            {!!textData && textData["sections/quotation"].edit_title_after}
                                        </h1>
                                        {getAmountOfSelectedModels() > 0 && (
                                            <>
                                                <span className="amount-of-models-icon"></span>
                                                <span className="amount-of-models">
                                                    {getAmountOfSelectedModels()}{" "}
                                                    {!!textData && textData["header"].selected}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                    <NavigationMenu
                                        textData={!!textData && textData}
                                        authenticated={props.authenticated}
                                        toggleLoginModal={setLoginModal}
                                        navigateToPageName={props.navigateToPageName}
                                    />
                                </div>
                                <Table
                                    data={!!modelsData && modelsData}
                                    onModelChange={setModelsData}
                                    textData={!!textData && textData["sections/quotation"]}
                                    textDataLabel={!!textData && textData["sections/label"]}
                                    checkoutState={!!state && state}
                                    popupData={!!textData && textData["popups/save_quotation"]}
                                    loginData={!!textData && textData["popups/login"]}
                                    mandatoryProductOptions={mandatoryProductSettings}
                                    navigateToPageName={props.navigateToPageName}
                                    getPageUrlByName={props.getPageUrlByName}
                                    saveQuotation={saveQuotation}
                                    saveQuotationAndRedirectCheckout={saveQuotationAndRedirectCheckout}
                                    allTextData={!!textData && textData}
                                    updateShippingCosts={updateShippingCosts}
                                    updatePrice={updatePrice}
                                    changedQuantity={setDisableProductSettings}
                                    forceUpdatePriceForModels={forceUpdatePriceForModels}
                                    updatingPrices={updatingPrices.current}
                                />
                            </div>
                        </>
                    )}
                    {activeNavigationMenuItem === "navigate-account" && (
                        <>
                            <div className="screen-left">
                                <Sidebar getPageUrlByName={props.getPageUrlByName} textData={!!textData && textData} />
                            </div>
                            <div className="screen-right">
                                <div className="header">
                                    <div className="header-title">
                                        {(props.currentPage === "account_orders" ||
                                            props.currentPage === "accountsettings") && (
                                            <>
                                                <FontAwesomeIcon icon={faUser} size="xl" />
                                                <h1>{props.title}</h1>
                                            </>
                                        )}
                                    </div>
                                    <NavigationMenu
                                        textData={!!textData && textData}
                                        authenticated={props.authenticated}
                                        navigateToPageName={props.navigateToPageName}
                                    />
                                </div>
                                {props.currentPage === "account_orders" && (
                                    <OrderOverview
                                        navigateToPageName={props.navigateToPageName}
                                        orderData={orders}
                                        textData={!!textData && textData}
                                    />
                                )}
                                {props.currentPage === "account_quotations" && (
                                    <QuotationOverview
                                        navigateToPageName={props.navigateToPageName}
                                        quotationData={savedQuotations}
                                        textData={!!textData && textData}
                                        loggedInUser={loggedInUser}
                                    />
                                )}
                                {props.currentPage === "account_settings" && (
                                    <Settings
                                        navigateToPageName={props.navigateToPageName}
                                        textData={!!textData && textData}
                                    />
                                )}
                                {props.currentPage === "account_details" && (
                                    <Details
                                        navigateToPageName={props.navigateToPageName}
                                        textData={!!textData && textData}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
            {isTabletOrMobile && (
                <div className="root">
                    {activeNavigationMenuItem === "navigate-quotation" && !!modelsData && (
                        <>
                            <div className={responsiveClass + "header"}>
                                <NavigationMenu
                                    textData={!!textData && textData}
                                    authenticated={props.authenticated}
                                    navigateToPageName={props.navigateToPageName}
                                    responsive={responsiveClass}
                                />
                            </div>
                            {!hasModelsSelected && (
                                <Upload
                                    type="model"
                                    responsive={responsiveClass}
                                    textData={!!textData && textData["sections/quotation"]}
                                    setModelsData={setModelsData}
                                />
                            )}
                            {hasModelsSelected && (
                                <ProductSettings
                                    modelsData={modelsData}
                                    updateModelSettings={updateModelSettings}
                                    textData={!!textData && textData}
                                    saveProductSettings={saveProductSettings}
                                    loggedInUser={loggedInUser}
                                    updateModelColor={updateModelColor}
                                    noSharing={true}
                                    disableProductSettings={disableProductSettings}
                                    updatingPrices={updatingPrices.current}
                                />
                            )}
                            <Table
                                responsive={responsiveClass}
                                data={!!modelsData && modelsData}
                                onModelChange={setModelsData}
                                textData={!!textData && textData["sections/quotation"]}
                                textDataLabel={!!textData && textData["sections/label"]}
                                navigateToPageName={props.navigateToPageName}
                                getPageUrlByName={props.getPageUrlByName}
                                saveQuotation={saveQuotation}
                                saveQuotationAndRedirectCheckout={saveQuotationAndRedirectCheckout}
                                allTextData={!!textData && textData}
                                updateShippingCosts={updateShippingCosts}
                                forceUpdatePriceForModels={forceUpdatePriceForModels}
                                updatePrice={updatePrice}
                                changedQuantity={setDisableProductSettings}
                            />
                        </>
                    )}
                    {activeNavigationMenuItem === "navigate-account" && !!orders && (
                        <>
                            <div className={responsiveClass + "header"}>
                                <NavigationMenu
                                    textData={!!textData && textData}
                                    authenticated={props.authenticated}
                                    navigateToPageName={props.navigateToPageName}
                                    responsive={responsiveClass}
                                />
                            </div>
                            <Sidebar textData={!!textData && textData} responsive={responsiveClass} />
                            {props.currentPage === "account_orders" && (
                                <OrderOverview
                                    navigateToPageName={props.navigateToPageName}
                                    responsive={responsiveClass}
                                    orderData={orders}
                                    textData={!!textData && textData}
                                />
                            )}
                            {props.currentPage === "account_quotations" && (
                                <QuotationOverview
                                    responsive={responsiveClass}
                                    quotationData={savedQuotations}
                                    textData={!!textData && textData}
                                    loggedInUser={loggedInUser}
                                />
                            )}
                        </>
                    )}
                </div>
            )}
            {tempModelViewers.map((modelViewer, index) => {
                return <Fragment key={index}>{modelViewer}</Fragment>;
            })}
        </>
    );
}
